var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftSpliter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 6,
    viewBox: "0 0 305 6",
    preserveAspectRatio: "xMidYMid slice",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M304.667 3C304.667 1.52724 303.473 0.333333 302 0.333333C300.527 0.333333 299.333 1.52724 299.333 3C299.333 4.47276 300.527 5.66667 302 5.66667C303.473 5.66667 304.667 4.47276 304.667 3ZM5.66666 3C5.66666 1.52724 4.47275 0.333333 3 0.333333C1.52725 0.333333 0.333344 1.52724 0.333344 3C0.333344 4.47276 1.52725 5.66667 3 5.66667C4.47275 5.66667 5.66666 4.47276 5.66666 3ZM302 2.5L3 2.5V3.5L302 3.5V2.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSpliter);
export default __webpack_public_path__ + "static/media/leftSpliter.c8bd60ff724a637c0b8a5cbc55a4e51f.svg";
export { ForwardRef as ReactComponent };